export enum SearchSuggestionType {
  PROFILE = 'PROFILE',
  STATIC_DATA = 'STATIC_DATA',
  TEXT = 'TEXT',
  PEOPLE_TEXT = 'PEOPLE_TEXT',
}
